import { HttpResponse, delay } from 'msw';
import { getResponseData } from '@/helpers/mocks';

const RESPONSE = {
  default: {
    response: {
      'globals.validations.required': 'שדה חובה',
      'globals.validations.email': 'יש להזין מייל תקין',
      'globals.validations.hebrew': 'יש להזין אותיות בעברית בלבד',
      'globals.validations.minLength': 'יש להזין לפחות {{count}} תווים',
      'globals.validations.minPropertyValue': 'לא ניתן להזין שווי נכס קטן מ־400,000 ₪',
      'globals.validations.uid': 'יש להזין תעודת זהות תקינה',
      'globals.validations.date': 'יש להזין תאריך תקין',
      'globals.validations.number': 'ניתן להזין ספרות בלבד',
      'globals.validations.phone': 'יש להזין טלפון תקין',
      'globals.validations.autocomplete': 'חובה לבחור פריט מהרשימה',
      'globals.validations.atLeast18years': 'חובה להזין תאריך לידה מלפני 18 שנה',
      'globals.validations.hebrewWithDigits': 'ניתן להזין ספרות ואותיות בעברית בלבד',
      'globals.validations.futureDate': 'לא ניתן להזין תאריך עתידי',
      'globals.validations.password': 'סיסמא חייבת להכיל 6 תויים ולפחות מספר אחד',
      'globals.validations.confirmPassword': 'הסיסמא לא זהה',
      'globals.validations.validPercent': 'יש להזין אחוז תקין בין 0 ל-100',
      'globals.yes': 'כן',
      'globals.no': 'לא',
      'globals.continue': 'המשך',
      'globals.back': 'חזור',
      'globals.add': 'הוספה',
      'globals.remove': 'הסרה',
      'globals.delete': 'מחיקה',
      'globals.submit': 'שליחה',
      'globals.edit': 'עריכה',
      'globals.save': 'שמירה',
      'globals.cancel': 'ביטול',
      'globals.close': 'סגירה',
      'globals.error.title': 'חלה שגיאה',
      'globals.error.message': 'התרחשה שגיאה בתהליך. אנא נסה שוב',
      'globals.unauthorized.title': 'לא מזוהה',
      'globals.unauthorized.message': 'לא נמצא משתמש עם הפרטים שהוזנו',
      'globals.privacyPolicy': 'מדיניות הפרטיות',
      'global.process.success.message': 'באפשרותך להתחיל את תהליך הייעוץ מול הלקוח על ידי יצירת הצעה חדשה והזנת פרטי הלקוח מחדש.',
      'global.process.success.title': '{{clientName}} אישר/ה את מדיניות הפרטיות שלנו',

      'components.head.action.news': 'הודעות',
      'components.head.action.help': 'עזרה',
      'components.aside.open': 'הרחב תפריט',
      'components.aside.close': 'צמצם תפריט',
      'components.aside.logout': 'התנתקות',

      'components.totalsComparison.title': 'השוואת סכומים לפני ואחרי החישוב',
      'components.totalsComparison.field': 'שדה',
      'components.totalsComparison.before': 'לפני',
      'components.totalsComparison.after': 'אחרי',
      'components.totalsComparison.improvement': 'שיעור השינוי',
      'components.totalsComparison.noDataAvailable': 'אין נתונים זמינים להשוואה',
      'components.totalsComparison.noChange': 'אין שינוי',
      'components.totalsComparison.decreasedBy': 'הופחת ב-{{amount}} ({{percentage}}%)',
      'components.totalsComparison.increasedBy': 'הוגדל ב-{{amount}} ({{percentage}}%)',
      'components.totalsComparison.decreasedByWithoutAmount': 'הופחת ב- ({{percentage}}%)',
      'components.totalsComparison.increasedByWithoutAmount': 'הוגדל ב- ({{percentage}}%)',
      'components.totalsComparison.totalAmount': 'למשכנתא בגובה',
      'components.totalsComparison.loanPeriod': 'לתקופה של',
      'components.totalsComparison.monthlyPayment': 'התשלום החודשי ההתחלתי של ההלוואה',
      'components.totalsComparison.interestRepayment': 'סך החזר הריבית בהלוואה',
      'components.totalsComparison.principalRepayment': 'תשלום קרן',
      'components.totalsComparison.finalPayment': 'סך ההחזר בסוף תקופת ההלוואה',
      'components.totalsComparison.linkageRepayment': 'סך החזר הצמדה בהלוואה',
      'components.totalsComparison.maxMonthlyPayment': 'תשלום חודשי מקסימלי',
      'components.totalsComparison.returnConversion': 'עבור כל שקל תשלום (יחס ההחזר)',
      'components.totalsComparison.summary': 'סיכום השיפור',
      'components.totalsComparison.summaryText': 'השוואה זו מראה את השיפור בתנאי ההלוואה שלך. ירידה בתשלומים החודשיים ובריבית, ועלייה בתשלום הקרן הם סימנים חיוביים.',

      'pages.proposalSummary.proposalSummary': 'תמהיל ההצעה',
      'pages.proposalSummary.borrowerlist': 'רשימת הלווים',
      'pages.proposalSummary.borrowerNumber': 'מספר הלווים',
      'pages.proposalSummary.loanType': 'סוג ההלוואה',
      'pages.proposalSummary.proprtyValue': 'שווי הנכס',
      'pages.proposalSummary.proprtyValueTooltipText': 'מומלץ לרשום על פי הערכת שמאי או חוזה מכר הנמוך מביניהם',
      'pages.proposalSummary.loanAmount': 'סכום ההלוואה',
      'pages.proposalSummary.borrowerName': 'שם הלווה',

      'pages.error.notFound': 'הדף שחיפשת לא קיים',

      'pages.main.title': 'דף ראשי',
      'pages.main.head.title': 'שלום, {{name}}',
      'pages.main.head.subtitle': 'מה ברצונך לעשות היום?',
      'pages.main.banner.title': 'פתיחת הצעה חדשה ללקוח חדש',
      'pages.main.banner.action': 'יצירת הצעה חדשה',
      'pages.main.stats.offers.title': 'הצעות פתוחות',
      'pages.main.stats.offers.subtitle': 'הצעות שנפתחו ללקוחות ועדיין מחכות לאישור וסגירה',
      'pages.main.stats.waiting.title': 'הצעות סגורות',
      'pages.main.stats.waiting.subtitle': 'הצעות שהלקוח ביצע תשלום והופק מסמך סיכום',
      'pages.main.stats.sent.title': 'הצעות שנשלחו',
      'pages.main.stats.sent.subtitle': 'הצעות שממתינות אצל הלקוח לחתימה והפקה',
      'pages.main.table.title': '5 הצעות אחרונות',
      'pages.main.table.footer': 'עבור לצפייה בכל ההצעות',
      'pages.main.table.head.uid': 'תעודת זהות',
      'pages.main.table.head.fullName': 'שם מלא',
      'pages.main.table.head.createdAt': 'נוצר בתאריך',
      'pages.main.table.head.status': 'סטטוס',
      'pages.main.noData': 'לא נמצאו נתונים',

      'pages.mortgageCyclesSummary.title.comparation': 'השוואה לפני/אחרי',
      'pages.mortgageCyclesSummary.table.label.totalAmount': 'סך הלוואה',
      'pages.mortgageCyclesSummary.table.label.paymentPerMonth': 'החזר חודשי',
      'pages.mortgageCyclesSummary.table.label.maxPaymentPerMonth': 'החזר מקסימלי',
      'pages.mortgageCyclesSummary.table.label.sumOfReturnsOfInterest': 'החזר ריבית',
      'pages.mortgageCyclesSummary.table.label.sumOfReturnsOfLinkage': 'החזר הצמדת מדד',
      'pages.mortgageCyclesSummary.table.label.totalPaymentInPeriodEnd': 'החזר בסוף תקופה',
      'pages.mortgageCyclesSummary.table.label.forEvryShekelYouWillPay': 'עבור כל שקל תשלם',
      'pages.mortgageCyclesSummary.table.head.index': 'מדד',
      'pages.mortgageCyclesSummary.table.head.before': 'לפני',
      'pages.mortgageCyclesSummary.table.head.after': 'אחרי',
      'pages.mortgageCyclesSummary.totalsComparison.title': 'פירוט נתוני המשכנתא הנוכחית מול נתוני המשכנתא המומלצת',

      'pages.error.error': 'אין מה לראות פה...',
      'pages.error.title': 'מצטערים',
      'pages.error.link.title': 'בחזרה לעמוד הראשי',

      'pages.proposal.title': 'הצעה חדשה',
      'pages.proposal.progress.borrower.info': 'עד 3 לווים להלוואה',

      'pages.reason.title': 'מטרת ההלוואה',
      'pages.reason.subtitle': 'בחירת סוג ההלוואה שברצונך לממש',
      'pages.reason.purpose': 'מטרת הרכישה / מטרת ההלוואה',
      'pages.reason.inputs.type': 'בחר את סוג ההלוואה',
      'pages.reason.inputs.loanAmount': 'סכום ההלוואה',
      'pages.reason.inputs.propertyValue': 'שווי הנכס',
      'pages.reason.inputs.propertyValueDescription': 'מומלץ לרשום על פי הערכת שמאי או חוזה מכר הנמוך מביניהם',
      'pages.reason.reverseMortgage.modal.title': 'זה קורה במשפחות הכי טובות!',
      'pages.reason.reverseMortgage.modal.body': 'לצערנו, לא אותרה חברה המאפשרת לקיחת משכנתא הפוכה בהתאם לתנאים שהוזנו.',

      'pages.reverseMortgage.title': 'תקופת ההלוואה',
      'pages.reverseMortgage.subtitle': 'אלו הנתונים שמצאנו מתאימים עבורכם',
      'pages.reverseMortgage.selectedPeriod': 'תקופת ההלוואה שנבחרה היא {{period}} שנים',

      'pages.mortgageCycle.bankFileUpload.title': 'העלאת קובץ משכנתא נוכחית',
      'pages.mortgageCycle.bankFileUpload.subtitle': 'על מנת לבצע בדיקת כדאיות מחזור המשכנתא יש להוציא ממערכת הבנק בו מתנהלת  המשכנתא הנוכחית דוח יתרות לסילוק',
      'pages.mortgageCycle.bankFileUpload.downloadFile': 'הורדת מסמך הסבר של כלל הבנקים',
      'pages.mortgageCycle.bankFileUpload.bankSelect.label': 'בחר בנק',
      'pages.mortgageCycle.bankFileUpload.fileUpload.label': 'הוסף את קובץ יתרת המשכנתא',
      'pages.mortgageCycle.bankFileUpload.fileUpload.placeholder': 'העלה קובץ PDF של המשכנתא הנוכחית',
      'pages.mortgageCycle.bankFileUpload.fileUpload.button.upload': 'בחר קובץ',
      'pages.mortgageCycle.bankFileUpload.fileUpload.supportedFormats': 'קבצי PDF בלבד, עד 2MB',
      'pages.mortgageCycle.bankFileUpload.button.scan': 'סרוק קובץ',
      'pages.mortgageCycle.bankFileUpload.mortgageCycleAction.label': 'כיצד תרצו לשפר את הלוואות הנוכחיות שלכם?',
      'pages.mortgageCycle.bankFileUpload.mortgageCycleAction.options.reducingRepaymentWithoutChangingThePeriod': 'הקטנת החזר ללא שינוי תקופה',
      'pages.mortgageCycle.bankFileUpload.mortgageCycleAction.options.reducingRepaymentNoPeriodChangeNew': 'באמצעות מחזור משכנתא ללא שינוי תקופה החיסכון ללקוחות יהיה',
      'pages.mortgageCycle.bankFileUpload.mortgageCycleAction.options.reducingRepaymentAndIncreasingTheLoanPeriod': 'הקטנת החזר והגדלת תקופת ההלוואה',
      'pages.mortgageCycle.bankFileUpload.mortgageCycleAction.options.increasingTheRepaymentAndReducingThePeriod': 'הגדלת ההחזר והקטנת תקופה',
      'pages.mortgageCycle.mortgageCycleAction.options.reductionRepaymentWithoutChangingTheTermByConsolidatingLoans': 'הקטנת החזר ללא שינוי תקופה',
      'pages.mortgageCycle.mortgageCycleAction.options.reductionOfRepaymentAndExtensionOfTheLoanTermThroughLoanConsolidation': 'הקטנת החזר והגדלת תקופת ההלוואה',

      'pages.mortgageCycle.bankFileUpload.notBetterToChange.title': 'הלוואות התשכנתא של הלקוח נראות טוב, אין לנו המלצות זמינות לשיפור',
      'pages.mortgageCycle.bankFileUpload.isMortgageRepaymentIncludedInPreviousLiabilities': 'האם סכום החזר המשכנתא נכלל בהתחייבויות שפורטו בשלב הקודם?',

      'pages.mortgageCycle.bankFileUpload.sectionTitle': 'כיצד ניתן להפיק דוח יתרה לסילוק משכנתא?',
      'pages.mortgageCycle.bankFileUpload.downloadButton': 'הורדה',
      'pages.mortgageCycle.bankFileUpload.bankInfoTitle': 'מידע עבור {{bankName}}',
      'pages.mortgageCycle.bankFileUpload.bankWebsite': 'אתר הבנק',
      'pages.mortgageCycle.bankFileUpload.bankPhone': 'טלפון',
      'pages.mortgageCycle.bankFileUpload.bankWorkingHours': 'שעות פעילות',
      'pages.mortgageCycle.bankFileUpload.bankInstructions': 'הוראות להפקת הדוח',
      'pages.mortgageCycle.bankFileUpload.button.scanAndContinue': 'סרוק והמשך',

      'pages.mortgageCycle.bankFileUpload.error.pdfReadFailed.title': 'לא ניתן לקרוא את הקובץ',
      'pages.mortgageCycle.bankFileUpload.error.pdfReadFailed.message': 'לא נמצאו נתוני הלוואות בקובץ שהועלה. ייתכן שהקובץ אינו מכיל מידע על הלוואות או שהפורמט אינו נתמך.',
      'pages.mortgageCycle.bankFileUpload.error.pdfProcessingFailed.title': 'שגיאה בעיבוד הקובץ',
      'pages.mortgageCycle.bankFileUpload.error.pdfProcessingFailed.message': 'אירעה שגיאה בעיבוד הקובץ שהועלה. אנא נסה שוב או בדוק שהקובץ תקין.',
      'pages.mortgageCycle.bankFileUpload.error.recommendations': 'המלצות',
      'pages.mortgageCycle.bankFileUpload.error.recommendation1': 'יש לוודא שהקובץ הוא קובץ PDF תקין',
      'pages.mortgageCycle.bankFileUpload.error.recommendation2': 'יש לוודא שהקובץ מכיל מידע על הלוואות',
      'pages.mortgageCycle.bankFileUpload.error.recommendation3': 'יש לנסות להעלות קובץ אחר או ליצור קשר עם קרדיט פרו',
      'pages.mortgageCycle.bankFileUpload.error.understandButton': 'הבנתי את הבעיה',

      'pages.mortgageCycle.existBankLoan.title': 'הלוואה בנקאית קיימת',
      'pages.mortgageCycle.existBankLoan.subtitle': 'הזן פרטי ההלוואה הבנקאית הקיימת שלך',
      'pages.mortgageCycle.existBankLoan.bankSelect.label': 'בחר בנק',
      'pages.mortgageCycle.existBankLoan.currentLoanAmount.label': 'סכום הלוואה נוכחי',
      'pages.mortgageCycle.existBankLoan.currentLoanAmount.placeholder': 'הזן את סכום ההלוואה הנוכחי שלך',

      'pages.mortgageCycle.currentMonthlyPayment': 'תשלום חודשי נוכחי',
      'pages.mortgageCycle.currentMonthlyPaymentDescription': 'זהו התשלום החודשי הנוכחי שלך',
      'pages.mortgageCycle.desiredMonthlyPayment': 'תשלום חודשי רצוי',
      'pages.mortgageCycle.newMonthlyPayment': 'תשלום חודשי חדש',
      'pages.mortgageCycle.enterDesiredAmount': 'הזן את הסכום החודשי הרצוי',
      'pages.mortgageCycle.desiredPaymentDescription': 'הזן את הסכום החודשי שברצונך לשלם',
      'pages.mortgageCycle.sendToConsultant': 'שלח לייעוץ',
      'pages.mortgageCycle.savingsSummary': 'סיכום החיסכון',
      'pages.mortgageCycle.monthlySaving': 'חיסכון חודשי',
      'pages.mortgageCycle.yearlySaving': 'חיסכון שנתי',
      'pages.mortgageCycle.totalSaving': 'חיסכון כולל',
      'pages.mortgageCycle.loanPeriod': 'תקופה ההלוואה',
      'pages.mortgageCycle.savingsDescription': 'תוכל להשתמש בחיסכון החודשי הזה לדברים שחשובים לך!',
      'pages.mortgageCycle.newMonthlyPaymentInfo': 'התשלום החודשי המעודכן של ההלוואה',
      'pages.mortgageCycle.monthlySavingInfo': 'סכום חודשי שנוכל לחסוך לכם',
      'pages.mortgageCycle.totalSavingInfo': '{{percentage}}% פחות לאורך תקופת המשכנתא',
      'pages.mortgageCycle.returnConversionTitle': 'סך ההחזר לכל שקל הלוואה',
      'pages.mortgageCycle.returnConversionInfo': 'במקום {{amount}} ₪ כיום',

      'pages.mortgageCycle.modal.title': 'שליחה לייעוץ',
      'pages.mortgageCycle.modal.successMessage': 'הבקשה שלך נשלחה לייעוץ בהצלחה!',
      'pages.mortgageCycle.modal.newRequest': 'בקשה חדשה',
      'pages.mortgageCycle.modal.returnToProposal': 'חזרה לדף ההצעה',

      'pages.extra.title': 'פרטי ההלוואה',
      'pages.extra.subtitle': 'כמה פרטים נוספים',
      'pages.extra.inputs.bankingIssues.title': 'האם במהלך שלוש השנים האחרונות היו לך בעיות בהתנהלות הבנקאית, כגון החזרות צ\'קים או הוראות קבע, חשבון מוגבל, עיקולים בהוצאה לפועל וכדומה?',
      'pages.extra.modal.title': 'בעיה עם ההצעה',
      'pages.extra.modal.body': 'לצערנו, לא ניתן להמשיך בתהליך עקב אי עמידה בתנאי ההתנהלות הבנקאית הנדרשים.',

      'pages.incomeLiabilities.totalIncome.label': 'סך הכנסות חודשיות נטו של הלקוחות (בשקלים ₪)',
      'pages.incomeLiabilities.totalIncome.description': 'הכנסות נטו כוללות של התא המשפחתי מעבודה (עצמאים לפי שומת מס) ומקצבה קבועה והכנסות פאסיביות כגון השכרת נכסים',
      'pages.incomeLiabilities.totalOutcome.label': 'סך התחייבויות חודשיות קבועות של הלקוחות (בשקלים ₪)',
      'pages.incomeLiabilities.totalOutcome.description': 'הוצאות בגין הלוואות עם יתרות לתשלום של מעל 18 חודש (כולל החזרי משכנתא קיימים) , תשלומי דמי מזונות וכל הוצאה על בסיס חודשי קבוע לתקופה ארוכה',

      'pages.loanAmount.title': 'סכום הלוואה',
      'pages.loanAmount.subtitle': 'סכום הלוואה',
      'pages.loanAmount.label': 'סכום הלוואה',
      'pages.loanAmount.description': 'סך הלוואת המשכנתא המקסמילי האפשרי הוא: לדירה יחידה עד 75% משווי הנכס, לשיפוץ והרחבה עד 75%, לדירה חלופית עד 70%, לדירה להשקעה עד 50% ולכל מטרה במשכון נכס עד 50% משווי הנכס .',

      'pages.borrower.title': 'פרטי הלווים',
      'pages.borrower.subTitle': 'ניתן להזין עד 3 לווים להלוואה',
      'pages.borrower.inputs.fullName': 'שם מלא',
      'pages.borrower.inputs.id': 'תעודת זהות',
      'pages.borrower.inputs.phone': 'מספר טלפון',
      'pages.borrower.inputs.dateOfBirth': 'תאריך לידה',
      'pages.borrower.inputs.idIssueDate': 'תאריך הנפקת תעודת זהות',
      'pages.borrower.inputs.idIssueDateDescription': 'תאריך ההנפקה מופיע בתעודת הזהות',
      'pages.borrower.inputs.email': 'כתובת מייל',
      'pages.borrower.inputs.emailDescription': 'ישמש בהמשך ליצירת קשר עם הלקוח',
      'pages.borrower.inputs.city': 'עיר מגורים',
      'pages.borrower.inputs.streetHouseNum': 'רחוב ומספר בית',
      'pages.borrower.inputs.zipCode': 'מיקוד',
      'pages.borrower.box.title': 'לווה מספר {{count}}',
      'pages.borrower.add': 'הוסף לווה נוסף',

      'pages.offer.title': 'פרטי ההצעה',
      'pages.offer.subtitle': 'לכמה שנים אתה מעוניין לפרוס את ההלוואה ({{min}} עד {{max}} שנים)?',
      'pages.offer.banner.regular.title': 'האם ברצונך להפחית את גובה ההחזר החודשי?',
      'pages.offer.banner.regular.subtitle': 'מעבר לתמהיל ברמת סיכון גבוה יותר יעניק החזר חודשי נמוך יותר',
      'pages.offer.banner.regular.action': 'מעבר לרמת סיכון גבוהה יותר',
      'pages.offer.banner.risk.title': 'האם ברצונך להפחית את רמת הסיכון?',
      'pages.offer.banner.risk.subtitle': 'מעבר לתמהיל ברמת סיכון נמוכה יותר יעניק החזר חודשי גבוה יותר',
      'pages.offer.banner.risk.action': 'מעבר לרמת סיכון נמוכה יותר',
      'pages.offer.years': 'שנים',
      'pages.offer.labels.years': 'מספר שנים נבחר',
      'pages.offer.labels.repaymentSum': 'סכום החזר נבחר',
      'pages.offer.labels.repaymentCapacity': 'כושר החזר',
      'pages.offer.labels.repaymentRatio': 'יחס החזר',
      'pages.offer.labels.minRepaymentPeriod': 'תקופת החזר מינימלית',
      'pages.offer.labels.maxRepaymentPeriod': 'תקופת החזר מקסימלית לפי גילך',
      'pages.offer.labels.maxRepaymentPeriod.tooltip': 'תקופת ההחזר המקסימאלית בהתחשב בגיל הלווים',
      'pages.offer.labels.repaymentMaxAmount': 'סכום החזר מקסימלי על פי להכנסתך',
      'pages.offer.labels.repaymentMaxAmount.tooltip': 'ההחזר ההתחלתי הכי גבוה שניתן לאשר על פי נתוני ההכנסה',
      'pages.offer.labels.repaymentMinAmount': 'סכום החזר מינימלי',
      'pages.offer.labels.repaymentMinAmount.tooltip': 'ההחזר ההתחלתי הכי נמוך שאליו ניתן להגיע',
      'pages.offer.box.title.regular': 'נתוני תמהיל ברמת סיכון נמוכה',
      'pages.offer.box.title.medium': 'נתוני תמהיל ברמת סיכון בנונית',
      'pages.offer.box.title.high': 'נתוני תמהיל ברמת סיכון גבוהה',
      'pages.offer.box.title.risk': 'נתוני תמהיל ברמת סיכון גבוהה',
      'pages.offer.card.favorite.title': 'אם תבחרו לעשות את זה איתנו',
      'pages.offer.card.favorite.text': 'הצעה מומלצת',
      'pages.offer.card.favorite.subtitle': 'זה הסכום שנוכל לחסוך עבורכם בסיום תקופת ההחזר',

      'pages.ReverseMortgageRouteType.options.interestPaymentOnly': 'מסלול תשלום ריבית חודשית',
      'pages.ReverseMortgageRouteType.options.paymentOfPrincipalAndInterest': 'מסלול תשלום קרן וריבית חודשי',
      'pages.ReverseMortgageRouteType.options.paymentAtTheEndOfThePeriod': 'מסלול ללא תשלום חודשי',
      'pages.routeType.errors.routeType': 'יש לבחור מסלול לפני שליחה ללקוחות לחתימה',

      'pages.ReverseMortgageRouteType.options.interestPaymentOnlyDescription': 'במסלול זה הלקוחות משלמים את גובה הריבית החודשית בלבד והקרן משולמת בתום תקופת ההלוואה',
      'pages.ReverseMortgageRouteType.options.paymentOfPrincipalAndInterestDescription': 'במסלול זה הלקוחות משלמים תשלום חודשי של קרן וריבית בהתאם ללוח הסילוקין של ההלוואה.',
      'pages.ReverseMortgageRouteType.options.paymentAtTheEndOfThePeriodDescription': 'במסלול זה הלקוחות אינם משלמים החזר חודשי כלשהו על חשבון ההלוואה והקרן והריבית משולמים בתום תקופת ההלוואה.',

      'pages.rate.title': 'ניהול מערכת',
      'pages.rate.planDetails': 'אופציה {1}',
      'pages.rate.planA': 'מסלול א',
      'pages.rate.planB': 'מסלול ב',
      'pages.rate.inputs.plan': 'מסלול',
      'pages.rate.inputs.recommendedPlan': 'אחוז מהסכום הכולל של המסלול',
      'pages.rate.inputs.HousingInterestRate': 'שיעור ריבית לדיור',
      'pages.rate.inputs.AverageBankInterestRate': 'שיעור ריבית ממוצעת לבנקים',
      'pages.rate.inputs.GeneralPurposeInterestRate': 'שיעור ריבית לכל מטרה',
      'pages.rate.inputs.AverageInterestRate': 'שיעור ריבית ממוצעת',
      'pages.rate.inputs.addRate': 'הוסף אופציה',
      'pages.rate.inputs.addPlan': 'הוסף מסלול',
      'pages.rate.inputs.fixedNotLinked': 'קבועה לא צמודה',
      'pages.rate.inputs.prime': 'פריים',
      'pages.rate.inputs.variableNotLinked18_24Months': 'משתנה לא צמודה 18/24 חודש',
      'pages.rate.inputs.variableNotLinked60Months': 'משתנה לא צמודה 60 חודש',
      'pages.rate.inputs.mkmOnlyLeumi': 'מק"מ (בבנק לאומי בלבד)',
      'pages.rate.inputs.fixedLinked': 'קבועה צמודה',
      'pages.rate.inputs.variableLinkedEveryTwoYears': 'משתנה צמודה כל שנתיים',
      'pages.rate.inputs.sumOfPlanMustBe100': 'סכום המסלולים המומלצים של מסלול זה חייב להיות 100% כדי להמשיך.',
      'pages.rate.inputs.approval': 'אישור',
      'pages.rate.inputs.error': 'שגיאה',
      'pages.rate.inputs.weight': 'הצמדה למדד',

      'pages.summary.title': 'סיכום ההצעה',
      'pages.summary.subtitle': 'להלן סיכום ההצעה למשכנתא בהתאם לנתונים שנמסרו על ידי הלקוח',
      'pages.summary.label.loanType': 'מטרת ההלוואה',
      'pages.summary.label.currentLoanAmount': 'גובה משכנתא נוכחית',
      'pages.summary.label.paymentPerMonth': 'החזר חודשי',

      'pages.existingMortgageSummary.modal.title': 'אישור שליחת נתונים',
      'pages.existingMortgageSummary.modal.confirmationMessage': 'אנא וודא שהנתונים הבאים נכונים לפני השליחה:',
      'pages.existingMortgageSummary.modal.bank': 'בנק',
      'pages.existingMortgageSummary.modal.currentLoanAmount': 'סכום הלוואה נוכחי',
      'pages.existingMortgageSummary.modal.loanAmount': 'סכום הלוואה מבוקש',
      'pages.existingMortgageSummary.modal.loanTypeNameHebrew': 'סוג הלוואה',
      'pages.existingMortgageSummary.modal.phoneNumber': 'מספר טלפון',
      'pages.existingMortgageSummary.modal.fullName': 'שם מלא',
      'pages.existingMortgageSummary.modal.message': 'הערות',
      'pages.existingMortgageSummary.modal.email': 'כתובת אימייל',
      'pages.existingMortgageSummary.modal.sendButton': 'שלח',
      'pages.existingMortgageSummary.successMessage': 'הנתונים נשלחו בהצלחה',
      'pages.summary.label.borrowerNumber': 'מספר הלווים',
      'pages.summary.label.loanAmount': 'סכום הלוואה המבוקשת',
      'pages.summary.label.paymentPeriodInMonths': 'תקופת ההלוואה בחודשים',
      'pages.summary.label.maxPaymentPerMonth': 'ההחזר הכי גבוה הצפוי במהלך תקופת המשכנתא',
      'pages.summary.label.returnOfInterest': 'החזר ריבית',
      'pages.summary.label.linkedReturn': 'החזר הצמדת מדד',
      'pages.summary.label.totalPaymentInPeriodEnd': 'סכום החזר בסוף התקופה',
      'pages.summary.label.sumOfReturnsOfInterest': 'החזר ריבית',
      'pages.summary.label.forEvryShekelYouWillPay': 'עבור כל שקל תשלם',
      'pages.summary.title.disposalBoardFor': 'לוח סילוקין ל',
      'pages.summary.title.borrowerDetails': 'פרטי הלווים',
      'pages.summary.label.fullName': 'שם מלא',
      'pages.summary.label.idNumber': 'תעודת זהות',
      'pages.summary.label.phoneNumber': 'טלפון',
      'pages.summary.title.planA': 'תוכנית א',
      'pages.summary.title.planB': 'ברמת סיכון גבוהה יותר',

      'pages.summary.table.head.month': 'חודש',
      'pages.summary.table.head.remaining': 'יתרת הקרן',
      'pages.summary.table.head.monthlyPaymentWithoutInterest': 'תשלום ע״ח קרן',
      'pages.summary.table.head.monthlyPaymentInterest': 'תשלום ע״ח ריבית',
      'pages.summary.table.head.totalPayment': 'החזר חודשי כולל',

      'pages.mortgageCyclesSummary.title': 'סיכום ההצעה',
      'pages.mortgageCyclesSummary.subtitle': 'להלן סיכום ההצעה שהתקבלה על בסיס הנתונים שנמסרו על ידי הלקוח',
      'pages.mortgageCyclesSummary.label.loanType': 'מטרת ההלוואה',
      'pages.mortgageCyclesSummary.label.paymentPerMonth': 'החזר חודשי',
      'pages.mortgageCyclesSummary.label.borrowerNumber': 'מספר הלווים',
      'pages.mortgageCyclesSummary.label.loanAmount': 'סכום הלוואה המבוקשת',
      'pages.mortgageCyclesSummary.label.paymentPeriodInMonths': 'תקופת ההלוואה בחודשים',
      'pages.mortgageCyclesSummary.label.maxPaymentPerMonth': 'ההחזר הכי גבוה הצפוי במהלך תקופת המשכנתא',
      'pages.mortgageCyclesSummary.label.returnOfInterest': 'החזר ריבית',
      'pages.mortgageCyclesSummary.label.linkedReturn': 'החזר הצמדת מדד',
      'pages.mortgageCyclesSummary.label.totalPaymentInPeriodEnd': 'סכום החזר בסוף התקופה',
      'pages.mortgageCyclesSummary.label.sumOfReturnsOfInterest': 'החזר ריבית',
      'pages.mortgageCyclesSummary.label.forEvryShekelYouWillPay': 'עבור כל שקל תשלם',
      'pages.mortgageCyclesSummary.title.disposalBoardFor': 'לוח סילוקין לאחר שיפור ההלוואות',
      'pages.mortgageCyclesSummary.title.borrowerDetails': 'פרטי הלווים',
      'pages.mortgageCyclesSummary.label.fullName': 'שם מלא',
      'pages.mortgageCyclesSummary.label.idNumber': 'תעודת זהות',
      'pages.mortgageCyclesSummary.label.phoneNumber': 'טלפון',

      'pages.mortgageCyclesSummary.table.head.month': 'חודש',
      'pages.mortgageCyclesSummary.table.head.remaining': 'יתרת הקרן',
      'pages.mortgageCyclesSummary.table.head.monthlyPaymentWithoutInterest': 'תשלום ע״ח קרן',
      'pages.mortgageCyclesSummary.table.head.monthlyPaymentInterest': 'תשלום ע״ח ריבית',
      'pages.mortgageCyclesSummary.table.head.totalPayment': 'החזר חודשי כולל',

      'pages.routeType.title': 'בחירת מסלול ליווי',
      'pages.routeType.subTitle': 'באפשרותך לבחור באחד משני ממסלולי הליווי להמשך התהליך',
      'pages.routeType.label.paymentRoute': 'מסלול ליווי',
      'pages.routeType.shortOption.label': 'מסלול בליווי חלקי',
      'pages.routeType.signRoute.label': 'חתימה בלבד',
      'pages.routeType.clinetRoute.label': 'שליחה ללקוח לצורך',
      'pages.routeType.signRoute.description': 'חתימה על ידי הלקוח ותשלום על ידי הסוכן',
      'pages.routeType.paymentRoute.label': 'חתימה ותשלום',
      'pages.routeType.paymentRoute.description': 'חתימה ותשלום על ידי הלקוח בלבד',
      'pages.routeType.shortOption.description': 'כולל שיחת יעוץ אחת עם יועץ של חברת קרדיט פרו בע"מ וקבלת הצעה מפורטת. עלות 1,300 ₪ + מע"מ (סה"כ 1,534 ₪)',
      'pages.routeType.longOption.label': 'מסלול בליווי מלא',
      'pages.routeType.longOption.description': 'כולל שיחת יעוץ וליווי מלא בכל תהליך קבלת המשכנתא עד לקבלתה. עלות 7,500 ₪ + מע"מ (סה"כ 8,850 ₪)',

      'pages.payment.title': 'מסך תשלום',
      'pages.payment.subTitle': 'בחרו את אופן התשלום',

      'pages.success.title': 'ה{{description}} נשלחה בהצלחה',
      'pages.success.subtitle': 'ניתן לצפות בהתקדמות התהליך במסכי הניהול',
      'pages.success.title.emailSendToClinet': 'הטופס נשלח בהצלחה ללקוח להמשך, ניתן לצפות בהתקדמות התהליך במסכי הניהול',
      'pages.success.button.downloadPdf': 'הורד את ההצעה',
      'pages.success.message.businessCredit': 'פנייתך הועברה בהצלחה. יועץ קרדיט פרו ייצור עם הלקוח קשר תוך 3 ימי עסקים',
      'pages.success.message.referral': 'פנייתך הועברה בהצלחה. יועץ קרדיט פרו ייצור עם הלקוח קשר תוך 3 ימי עסקים',
      'pages.success.message.reverseMortgage': 'פנייתך הועברה בהצלחה. יועץ קרדיט פרו ייצור עם הלקוח קשר בהקדם',
      'pages.success.message.mortgageRefinancing': 'פנייתך הועברה בהצלחה. יועץ קרדיט פרו ייצור עם הלקוח קשר בהקדם',

      'pages.settings.pages.mixes.title': 'ניהול תמהילים',
      'pages.settings.pages.mortgageCycleMixes.title': 'ניהול תמהילי מחזור משכנתא',
      'pages.settings.pages.rate.title': 'ניהול ריביות',
      'pages.settings.pages.reverseMortgage.title': 'ניהול משכנתא הפוכה',
      'pages.settings.pages.mixes.description': 'ניתן להוסיף, לערוך ולמחוק תמהילים',
      'pages.settings.pages.mortgageCycleMixes.description': 'ניתן להוסיף, לערוך ולמחוק תמהילים',
      'pages.settings.pages.rate.description': 'ניתן לערוך ריביות לפי המסלולים השונים',

      'pages.settings.pages.reverseRate.save': 'שמור',
      'pages.settings.pages.reverseRate.title': 'ניהול ריביות משכנתא הפוכה',
      'pages.settings.pages.reverseRate.description': 'ניתן לערוך ריביות לפי חברות',
      'pages.settings.pages.reverseRate.noData': 'לא נמצאו נתונים',
      'pages.settings.pages.reverseRate.table.headers.company': 'חברה',
      'pages.settings.pages.reverseRate.table.headers.present': 'אחוזי ריבית',
      'pages.settings.pages.reverseRate.table.headers.actions': 'פעולות',

      'pages.login.title': 'התחברות',
      'pages.login.inputs.email': 'מייל',
      'pages.login.inputs.password': 'סיסמה',
      'pages.login.action': 'התחבר',
      'pages.login.sessionExpired': 'החיבור למערכת הסתיים – אנא התחברו שוב להמשך השימוש',

      'pages.userlist.title': 'ניהול משתמשים',
      'pages.userlist.createUser': 'הוסף משתמש',
      'pages.userlist.headers.role': 'תפקיד',
      'pages.userlist.headers.email': 'מייל',
      'pages.userlist.headers.status': 'סטטוס',
      'pages.userlist.noData': 'אין משתמשים להצגה',
      'pages.userlist.editUser': 'ערוך משתמש',

      'pages.usercreate.title': 'יצירת משתמש',
      'pages.usercreate.form.email': 'מייל',
      'pages.usercreate.form.password': 'סיסמא',
      'pages.usercreate.form.confirmPassword': 'אמת סיסמא',
      'pages.usercreate.form.role': 'תפקיד',
      'pages.usercreate.form.status': 'סטטוס',

      'pages.useredit.status.active': 'פעיל',
      'pages.useredit.status.blocked': 'חסום',
      'pages.useredit.title': 'ערוך סוכן',

      'pages.lead.headers.name': 'שם',
      'pages.lead.headers.email': 'מייל',
      'pages.lead.headers.phone': 'טלפון',
      'pages.lead.headers.message': 'הודעה',
      'pages.lead.headers.loanAmount': 'סכום ההלוואה',
      'pages.lead.headers.period': 'תקופת ההלוואה',
      'pages.lead.headers.loanType': 'סוג ההלוואה',
      'pages.lead.headers.actions': 'פעולות',
      'pages.lead.noData': 'אין לידים להצגה',
      'pages.lead.moreInformation': 'למידע נוסף',
      'pages.lead.title': 'רשימת לידים',

      'pages.businessCredit.title': 'אשראי עסקי',
      'pages.businessCredit.subtitle': 'יש למלא את הפרטים הנדרשים על החברה ועל גובה האשראי ולהעביר ליועץ קרדיט פרו אשר ייצור קשר עם הלקוח להמשך התהליך',
      'pages.businessCredit.companyInfo.title': 'מידע על החברה',
      'pages.businessCredit.companyInfo.companyName': 'שם החברה',
      'pages.businessCredit.companyInfo.companyNamePlaceholder': 'הכנס את שם החברה',
      'pages.businessCredit.companyInfo.companyNumber': 'מספר ח.פ.',
      'pages.businessCredit.companyInfo.companyNumberPlaceholder': 'הכנס מספר ח.פ.',
      'pages.businessCredit.companyInfo.creditAmount': 'סכום האשראי/הלוואה המבוקש',
      'pages.businessCredit.companyInfo.creditAmountPlaceholder': 'הכנס סכום',
      'pages.businessCredit.contactInfo.title': 'איש קשר להמשך התהליך',
      'pages.businessCredit.contactInfo.contactName': 'שם איש הקשר',
      'pages.businessCredit.contactInfo.contactNamePlaceholder': 'הכנס שם מלא',
      'pages.businessCredit.contactInfo.contactPhone': 'טלפון של איש הקשר',
      'pages.businessCredit.contactInfo.contactPhonePlaceholder': 'הכנס מספר טלפון',
      'pages.businessCredit.contactInfo.contactRole': 'תפקיד איש הקשר בחברה',
      'pages.businessCredit.contactInfo.contactRolePlaceholder': 'הכנס תפקיד',
      'pages.businessCredit.transferToConsultant': 'העבר ליועץ CreditPro',
      'pages.businessCredit.modal.title': 'בקשת האשראי נשלחה בהצלחה',
      'pages.businessCredit.modal.successMessage': 'פנייתך הועברה בהצלחה.\nהיועץ אופיר כהן ייצור אתך קשר תוך 3 ימי עסקים',
      'pages.businessCredit.modal.message': 'המידע נשלח ליועץ CreditPro. מה תרצה לעשות עכשיו?',
      'pages.businessCredit.modal.newRequest': 'שלח בקשת אשראי נוספת',
      'pages.businessCredit.modal.returnToMain': 'חזור לדף הראשי',
      'pages.businessCredit.error.fillRequiredFields': 'אנא מלא את כל השדות הנדרשים',
      'pages.businessCredit.error.saveError': 'שגיאה בשמירת המידע',

      'pages.proposals.headers.agentName': 'שם',
      'pages.proposals.headers.borrowers': 'מספר לווים',
      'pages.proposals.headers.updatedAt': 'עודכן בתאריך',
      'pages.proposals.actions.sentToclient': 'שלח ללקוח',
      'pages.proposals.actions.edit': 'ערוך הצעה',
      'pages.proposals.headers.statusName': 'סטטוס',
      'pages.proposals.actions.summary': 'צפה בסיכום',
      'pages.proposals.headers.message': 'הודעה',
      'pages.proposals.headers.createdAt': 'נוצר בתאריך',
      'pages.proposals.headers.actions': 'פעולות',
      'pages.proposals.noData': 'אין הצעות להצגה',
      'pages.proposals.moreInformation': 'למידע נוסף',
      'pages.proposals.title': 'רשימת הצעות',
      'pages.proposals.actions.download': 'להורדה',

      'components.contact.title': 'צור קשר',
      'components.contact.selectLabel': 'בחר לקוח',
      'components.contact.fullName': 'שם מלא',
      'components.contact.phone': 'טלפון',
      'components.contact.email': 'מייל',
      'components.contact.message': 'הודעה',

      'pages.uploadBankFile.title': 'מידע על המשכנתא הנוכחית של הלקוח',
      'pages.uploadBankFile.subtitle': 'לבדיקת אפשרויות למחזור משכנתא וכדאיותה, יש לספק מידע על היתרות לסילוק של המשכנתא הנוכחית של הלקוחות. קובץ עם פירוט היתרות לסילוק ניתן לקבל ממערכת הבנק בו מתנהלת המשכנתא הנוכחית שלהם.',

      'pages.loansComparation.title': 'נתוני המשכנתא הנוכחית של הלקוח',
      'pages.loansComparation.validations.invalidInterest': 'ריבית לא תקינה בהלוואות: {{loans}}',
      'pages.loansComparation.validations.missingInterest': 'חסרים נתונים בהלוואה — יש להזין ריבית',

      'pages.mortgageCycleAction.title': 'פרטי ההצעה שלנו לשיפור',
      'pages.mortgageCycleAction.cycleWithAdditionalLoan.title': 'פוטנציאל החיסכון במחזור המשכנתא',
      'pages.mortgageCycleAction.cycleWithAdditionalLoan.subtitle': 'באמצאות מחזור משכנתא ללא שינוי תקופה החיסכון ללקוחות יהיה',
      'pages.mortgageCycleAction.cannotExtendLoanPeriod': 'לא ניתן להאריך את תקופת ההלוואה באפשרותך לחזור למסך הקודם ולמחזר את ההלוואה ללא שינוי תקופה',
      'pages.mortgageCycleAction.cycleWithAdditionalLoan.comments': 'הערות:',
      'pages.mortgageCycleAction.cycleWithAdditionalLoan.commentsList.first': 'הנתונים לעיל מציגים את סך ההחזר החודשי, ההחזר הכולל ויתרת המשכנתא בתנאי ריבית קרדיט פרו, ביחס לתנאי הריבית הקיימים, בהנחה ותקופת ההלוואות הממוחזרות וסכומן נותרים ללא שינוי.',
      'pages.mortgageCycleAction.cycleWithAdditionalLoan.commentsList.second': 'סך הלוואות המשכנתא המומלצות למחזור ע"י מערכת קרדיט פרו, יוסף לסכום התוספת המבוקשת בשלבים הבאים, ותקופת ההלוואות אלו תהיה זהה בהתאם לבחירת הלקוחות.',
      'pages.mortgageCycleAction.cycleWithAdditionalLoan.commentsList.third': 'בשלבים הבאים יוצג החיסכון הכולל האפשרי בתשלומים העתידיים של ההלוואות המשכנתא החדשה על כל מרכיביה בהתאם להמלצת מערכת קרדיט פרו, ביחס לתנאי הריבית הנהוגים כיום בבנקים.',

      'components.inactivity.button.continue': 'לחץ להמשך פעילות ({{count}})',
      'components.inactivity.modal.title': 'יש כאן מישהו?',
      'components.inactivity.modal.body.continue': 'חלף זמן רב מאז נעשה שימוש במערכת. לשמירה מפני שימוש חריג, תנותק מהמערכת בקרוב. במידה וברצונך להמשיך לעבוד במערכת יש ללחוץ על המשך.',

      'components.pdfPageSelector.title': 'בחירת עמודים מהקובץ',
      'components.pdfPageSelector.pages': 'עמודים',
      'components.pdfPageSelector.page': 'עמוד',
      'components.pdfPageSelector.selected': 'נבחרו',
      'components.pdfPageSelector.total': 'סה"כ',
      'components.pdfPageSelector.selectAll': 'בחר הכל',
      'components.pdfPageSelector.deselectAll': 'בטל בחירה',
      'components.pdfPageSelector.selectMore': 'בחר עוד',
      'components.pdfPageSelector.showPreview': 'הצג תצוגה מקדימה',
      'components.pdfPageSelector.hidePreview': 'הסתר תצוגה מקדימה',
      'components.pdfPageSelector.loading': 'טוען עמודים...',
      'components.pdfPageSelector.cancel': 'ביטול',
      'components.pdfPageSelector.confirm': 'אישור',
      'components.pdfPageSelector.section.title': 'בחר את העמודים בם מופיעים נתוני הלוואות המשכנתא של הלקוח במסמך.',
      'components.pdfPageSelector.section.list.first': 'עמודים אלו הם בד"כ העמודים הראשונים במסמך והם מכילים בעיקר מספרים (סכומי ההלוואה, נתוני ריביות והצמדות וכו׳) בשילוב של מידע נוסף.',
      'components.pdfPageSelector.section.list.second': 'עמודים המכילים בעיקר תוכן כתוב והנראים כמסמך משפטי, הם עמודי הסבר והנחיות אותם אין לבחור היות והם משבשים את קריאת המידע על ההלוואות.',
      'components.pdfPageSelector.selectAtLeastOne': 'בחר לפחות עמוד אחד',
      'components.pdfPageSelector.error.title': 'שגיאה בטעינת הקובץ',
      'components.pdfPageSelector.previewUnavailable.title': 'תצוגה מקדימה לא זמינה',
      'components.pdfPageSelector.previewUnavailable.message': 'לא ניתן להציג תצוגה מקדימה של העמודים. תוכל לבחור עמודים לפי מספר העמוד.',
      'components.pdfPageSelector.selectionLimits': 'מינימום: 1 עמוד, מקסימום: 15 עמודים',

      'components.sendDetailsModal.send': 'שלח ליועץ CreditPro',

      'pages.mortgageCycle.bankFileUpload.pagesSelected.title': 'עמודים נבחרו',
      'pages.mortgageCycle.bankFileUpload.pagesSelected.message': 'נבחרו {{count}} עמודים מהקובץ',
      'pages.mortgageCycle.bankFileUpload.selectedPages.title': 'עמודים נבחרים',
      'pages.mortgageCycle.bankFileUpload.selectedPages.message': 'נבחרו {{count}} עמודים: {{pages}}',
      'pages.mortgageCycle.bankFileUpload.selectedPages.edit': 'ערוך בחירה',

      'pages.customizedMix.title': 'מחשבון משכנתא',
      'pages.customizedMix.headerText': 'תמהילי משכנתא - בנייה והשוואה',
      'pages.customizedMix.subtitle': 'לבניית תמהיל משכנתא יש להזין את הנתונים הנדרשים. להשוואה בין התמהילים יש ללחוץ על הכפתור "להשוואה".',
      'pages.customizedMix.tab.label': 'תמהיל {{index}}',
      'pages.customizedMix.addMix.title': 'הוסף תמהיל',
      'pages.customizedMix.tab.content.title': 'הרכב מסלולים',
      'pages.customizedMix.addTranche.title': 'הוסף מסלול חדש לתמהיל',
      'pages.customizedMix.totals.title': 'סיכום תמהיל חדש',
      'pages.customizedMix.continueButton.title': 'להשוואה',
      'pages.customizedMix.summaryBoxes.totalAmount': 'סכום הלוואה כולל',
      'pages.customizedMix.summaryBoxes.totalMonthlyPayment': 'החזר חודשי כולל',
      'pages.customizedMix.summaryBoxes.totalInterestPayment': 'החזר ריבית כולל',
      'pages.customizedMix.summaryBoxes.maxMonthlyPayment': 'החזר חודשי מקסימלי',

      'components.CustomizedMixTrancheDetails.amount.label': 'סכום',
      'components.CustomizedMixTrancheDetails.tranche.label': 'מסלול',
      'components.CustomizedMixTrancheDetails.goal.label': 'מטרת ההלוואה',
      'components.CustomizedMixTrancheDetails.period.label': 'תקופה בחודשים',
      'components.CustomizedMixTrancheDetails.totals.totalMonthlyRepayment': 'החזר חודשי:',
      'components.CustomizedMixTrancheDetails.totals.totalRepayment': 'החזר כולל:',
      'components.CustomizedMixTrancheDetails.totals.linkage': 'מדד:',
      'components.CustomizedMixTrancheDetails.totals.interest': 'ריבית:',

      'pages.customizedMixSummary.title': 'סיכום התמהילים',
      'pages.customizedMixSummary.headerText': 'תמהילי משכנתא - בניה והשוואה',
      'pages.customizedMixSummary.subtitle': 'להלן השוואה בין תמהילי המשכנתא אשר בנית:',
      'pages.customizedMixSummary.exportButton.title': 'ייצוא ל-PDF',
      'pages.customizedMixSummary.summaryMixes.title': 'ריכוז התמהילים שבנית',
      'pages.customizedMixSummary.comparedMixes.title': 'סיכום והשוואת התמהילים',
      'pages.customizedMixSummary.compareMixesSection.totalAmount': 'סך ההלוואה',
      'pages.customizedMixSummary.compareMixesSection.totalMonthlyPayment': 'החזר חודשי כולל',
      'pages.customizedMixSummary.compareMixesSection.totalInterestPayment': 'החזר ריבית כולל',
      'pages.customizedMixSummary.compareMixesSection.maxMonthlyPayment': 'החזר מקסימלי',
      'pages.customizedMixSummary.compareMixesSection.totalLinkagePayment': 'החזר הצמדת מדד כולל',
      'pages.customizedMixSummary.compareMixesSection.totalRepayment': 'סכום ההחזר הכולל',
      'pages.customizedMixSummary.compareMixesSection.repaymentPerShekel': 'החזר לכל שקל הלוואה',
      'pages.customizedMixSummary.graphSection.title': 'השוואת נתוני החזר חודשי',
    },
    status: 200,
  },

  error: {
    response: {
      createdAt: 1701115461239,
      object: 'login',
      success: false,
    },
    status: 500,
  },
};

const localesHeHandler = async () => {
  const { response, status } = getResponseData(RESPONSE);
  await delay(0);
  return HttpResponse.json(response, status);
};

export {
  localesHeHandler,
};
